import EditController from './forms/EditController';
import Edit from './forms/Edit.vue';
import List from './forms/List.vue';
import ListController from './forms/ListController';

const formatQty = (value: any) => {
	const n = parseFloat(value);
	if (isNaN(n) || n === 0) return '0';
	return n.toFixed(3).replace(/\.?0+$/, '');
};

export default {
	description: "Накладные-требования",
	forms: {
		edit: {
			component: Edit,
			controller: EditController,
		panel: {
			width: '90%',
			modal: false
		}
		},
		list: {
			component: List,
			controller: ListController,
			config: {
				fields: {
					id: {
						config: {
							visible: false,
							hide: true
						}
					},
					requirement_number: {
						description: 'Номер',
						config: {
							width: '120px',
							sticky: true,
							visible: true,
							sorting: 'CAST("invoice_requirements"."requirement_number" AS INTEGER)'
						}
					},
					approval_date: {
						description: 'Дата',
						config: {
							width: '130px',
							visible: true,
							sorting: '"invoice_requirements"."approval_date"'
						}
					},
					requested_by_id: {
						description: 'Затребовано',
						config: {
							width: '200px',
							visible: true,
							reference: 'consignees',
							displayField: 'name',
							sorting: '"requested_by_id"."name"'
						}
					},
					positions_summary: {
						description: 'Позиции (наименование — затр. / отп.)',
						config: {
							width: '520px',
							visible: true,
							render: (_value: any, row: any) => {
								const items = Array.isArray(row?.items) ? row.items : [];
								if (!items.length) return '';
								return items
									.filter((item: any) => !item?.deletionmark)
									.map((item: any) => {
										const name = item?.product_name || '—';
										const requested = formatQty(item?.quantity_requested);
										const issued = formatQty(item?.quantity_issued);
										return `${name} — ${requested} / ${issued}`;
									})
									.join('; ');
							}
						}
					},
					requested_mol_fio: {
						description: 'ФИО МОЛ (затребовано)',
						config: {
							width: '200px',
							visible: true,
							sorting: '"invoice_requirements"."requested_mol_fio"'
						}
					},
					issued_by_id: {
						description: 'Отпущено',
						config: {
							width: '200px',
							visible: true,
							reference: 'consignees',
							displayField: 'name',
							sorting: '"issued_by_id"."name"'
						}
					},
					issued_mol_fio: {
						description: 'ФИО МОЛ (отпущено)',
						config: {
							width: '200px',
							visible: true,
							sorting: '"invoice_requirements"."issued_mol_fio"'
						}
					},
					approved_by_id: {
						description: 'Сотрудник',
						config: {
							width: '200px',
							visible: true,
							reference: 'users',
							displayField: 'name',
							sorting: '"approved_by_id"."name"'
						}
					},
					status: {
						description: 'Статус',
						config: {
							width: '150px',
							visible: true,
							sorting: '"invoice_requirements"."status"',
							display: (value: any, row: any) => {
								const status = (value || '').toString().trim().toLowerCase();
								if (status === 'requested') return 'Затребовано';
								if (status === 'requested_by_request' || status === 'deficit') return 'Затребовано по заявке';
								if (status === 'approved') return row && (row.is_deficit === true || row.is_deficit === 'true') ? 'Затребовано по заявке' : 'Затребовано';
								if (status === 'issued') return 'Отпущено';
								// Для обратной совместимости: проверяем is_deficit
								if (row && (row.is_deficit === true || row.is_deficit === 'true')) return 'Затребовано по заявке';
								return '';
							}
						}
					},
					mol_fio: {
						description: 'ФИО МОЛ',
						config: {
							visible: false
						}
					},
					created_at: {
						description: 'Создано',
						config: {
							visible: false,
							hide: true
						}
					},
					updated_at: {
						description: 'Обновлено',
						config: {
							visible: false,
							hide: true
						}
					},
					deletionmark: {
						description: 'Пометка удаления',
						config: {
							visible: false,
							hide: true
						}
					},
					is_deficit: {
						description: 'Заявка на дефицит',
						config: {
							visible: false,
							hide: true
						}
					}
				}
			}
		}
	},
	columns: [
		{
			field: 'requirement_number',
			description: 'Номер',
			width: 120,
			sticky: true
		},
		{
			field: 'approval_date',
			description: 'Дата',
			width: 130
		},
		{
			field: 'requested_by_id',
			description: 'Затребовано',
			width: 200,
			render: (row: any) => row._requested_by_id || row.requested_by_id || ''
		},
		{
			field: 'issued_by_id',
			description: 'Отпущено',
			width: 200,
			render: (row: any) => row._issued_by_id || row.issued_by_id || ''
		},
		{
			field: 'status',
			description: 'Статус',
			width: 150,
			render: (row: any) => {
				const status = (row._status || row.status || '').toString().trim().toLowerCase();
				if (status === 'requested') return 'Затребовано';
				if (status === 'requested_by_request' || status === 'deficit') return 'Затребовано по заявке';
				if (status === 'approved' || status === 'утверждено' || status === 'согласовано') {
					return (row.is_deficit === true || row.is_deficit === 'true') ? 'Затребовано по заявке' : 'Затребовано';
				}
				if (status === 'issued' || status === 'отпущено') return 'Отпущено';
				if (row.is_deficit === true || row.is_deficit === 'true') return 'Затребовано по заявке';
				return '';
			}
		}
	]
};

